import React from "react";
import { MenuItem, ListItemText, ListItemIcon, Typography } from "@mui/material/";
import Select from "@mui/material/Select";
import styles from "../../screens/dashboard/dashboard.module.css";
import FormControl from "@mui/material/FormControl";
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import themeStyle from "utils/styles/theme.style";

export default function FormControlComponent(props) {
    const { groupData, setGroup, group, formName } = props
    const handleChange = (event) => {
        setGroup(event.target.value);
    };

    return (
        <FormControl size="small">
            <Select
                sx={{
                    color: themeStyle.color.secondary,
                    backgroundColor: "white",
                    height: 35,
                    '.MuiOutlinedInput-notchedOutline': {
                        borderColor: themeStyle.color.secondary,
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: themeStyle.color.secondary,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: themeStyle.color.secondary,
                    },
                    '.MuiSvgIcon-root ': {
                        fill: themeStyle.color.secondary,
                    }
                }}
                labelId="demo-select-small"
                id="demo-select-small"
                //autoWidth
                value={group}
                onChange={handleChange}
                displayEmpty
                renderValue={
                    group !== ''
                        ? () => <div style={{ display: "flex", alignItems: "center", overflow: "hidden", textOverflow: "ellipsis", width: 105 }}>
                            <span className={styles.autoSelect}>{groupData.filter((item) => item?.id === group)[0]?.name}</span>
                        </div>
                        : () => <div style={{ display: "flex", alignItems: "center", overflow: "hidden", textOverflow: "ellipsis", width: 105 }}>
                            <span className={styles.autoSelect}>{formName}</span>
                        </div>
                }
            >
                {groupData.map((group) => (
                    <MenuItem
                        key={group.id}
                        value={group.id}
                        sx={{
                            color: "#777777",
                            "&:hover": {
                                backgroundColor: "#ECF9F7",
                                color: "#444444",
                            },
                        }}
                    >
                        <div style={{ display: "flex", alignItems: "center", overflow: "hidden", textOverflow: "ellipsis", width: 120, maxHeight: 20 }}>
                            <ListItemIcon>
                                <PeopleAltIcon sx={{
                                    color: themeStyle.color.secondary,
                                    maxHeight: 20,
                                }} />
                            </ListItemIcon>
                            <ListItemText sx={{ fontSize: "13px" }} primary={<Typography variant="h2" style={{ fontSize: "14px", textAlign: "start", color: "inherit" }}>{group.name}</Typography>} />
                        </div>
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
